import React from "react";
import { Modal, Button } from "antd";

const AddOnConfirmationModal = ({ open, visible, onCancel, onChoose, onRepeat }) => {
  const isOpen = open ?? visible;
  return (
    <Modal open={isOpen} centered onCancel={onCancel} footer={null}>
      <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "20px" }}>
        <Button
          style={{ backgroundColor: "#FFA500", color: "white", border: "none", width: "16vw" }}
          onClick={onChoose}
        >
          I'll choose
        </Button>
        <Button
          type="default"
          style={{ width: "16vw" }}
          onClick={onRepeat}
        >
          Repeat The Same
        </Button>
      </div>
    </Modal>
  );
};

export default AddOnConfirmationModal;
